"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NoAuthSession = void 0;
/**
 * Adapters can use this to notify that there is no existing session on client.
 *
 * This is useful for error handling to be able to disambiguate between a failure and a missing session.
 * */
class NoAuthSession extends Error {
    constructor(message) {
        super(message !== null && message !== void 0 ? message : 'NO_AUTH_SESSION');
        this.errorType = 'NoAuthSession';
    }
}
exports.NoAuthSession = NoAuthSession;
